import { render, staticRenderFns } from "./DialogEditMaterial.vue?vue&type=template&id=c7bb2b90&"
import script from "./DialogEditMaterial.vue?vue&type=script&lang=js&"
export * from "./DialogEditMaterial.vue?vue&type=script&lang=js&"
import style0 from "./DialogEditMaterial.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports